<template>
  <div class="advertising">
    <NavBar1 type="introduce" />
<!--    <NavBar2 v-if="scrollTop>0" type="product" />-->
    <div class="banner">
      <div class="title">AI业绩增长解决方案领导者</div>
    </div>
    <div class="content">
      <div class="wow slideInUp company-introduction-content">
        <div class="content-box">
          <div class="title">公司介绍</div>
          <div class="subtitle">
            北京云晰科技有限公司是AI智能体解决方案服务商，公司成立于2018年9月总部位于北京，是北京市高新技术企业。公司已获得多轮融资，并已成功服务上千家机构。公司专注公私域直播社群运营和用户裂变，通过AI智能体为客户提供从获客转化到管理的整体解决方案。
          </div>
        </div>
      </div>
      <img class="wow slideInUp" src="https://resource.51beauty.com.cn/qianduan_forever/8a9aefa14a4640b79bac0a2795f0d4ac/development-history.png" alt="">
      <div class="wow slideInUp management-team-content">
        <div class="title">
          管理团队
        </div>
        <div class="subtitle">
          核心团队中多位是连续创业者，对多个行业都有很深的洞察和理解，<br />
          服务网络遍及全国100余个城市。在华北、华南、西南、华东、华中设立分支机构。
        </div>
      </div>
      <div class="wow slideInUp list-content">
        <div class="list-item" v-for="(item,index) in list" :key="index">
          <div class="title-img">
            <div class="title">{{item.title}}</div>
            <img :src="item.img" alt=""/>
          </div>
          <div class="subtitle">{{item.subtitle}}</div>
        </div>
      </div>
      <!-- <img class="wow slideInUp" src="https://resource.51beauty.com.cn/7a1e6cf3-e1c0-4d8e-8f48-5e2665420342?imageslim" alt="">
      <img class="wow slideInUp" src="https://resource.51beauty.com.cn/8b5de164-c206-4429-bb73-399fc000a99f?imageslim" alt="">
      <img class="wow slideInUp" src="https://resource.51beauty.com.cn/fcf339d6-cecc-4097-a7b4-e7006110fb51?imageslim" alt=""> -->
    </div>
    <div class="exhibition">
      <div class="exhibition_con">
        <div>新闻与活动</div>
        <div class="wow slideInUp">
          <div class="exhibition_item" @click="article('https://cloud.tencent.com/developer/article/1892234?from=article.detail.1902177')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/f17ab896-e595-4a3e-bda8-7258a73e1e48?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">腾讯SaaS加速器三期总决选</div>
              <div class="subtitle">云晰科技从1100家报名SaaS企业中顺利突围，获得最终角逐Top 40席位的入场券。</div>
            </div>
          </div>
          <div class="exhibition_item" @click="article('https://cloud.tencent.com/document/product/306/47166')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/a5826992-7c89-4adf-bbca-c986ca84e718?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">云晰科技已通过腾讯云千帆计划复选</div>
              <div class="subtitle">营销云产品已上架腾讯云市场，成为“千帆甄选”推荐产品。</div>
            </div>
          </div>
          <div class="exhibition_item" @click="article('https://baijiahao.baidu.com/s?id=1718001203675989497&wfr=spider&for=pc')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/4bc47af4-78d0-4a64-95b3-be41e94b212e?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">云晰科技和企业微信官方合作组织沙龙会</div>
              <div class="subtitle">云晰与企业微信深度合作共创，将企微作为腾讯新流量生态的结合点，帮助客户探索私域增长…</div>
            </div>
          </div>
        </div>
      </div>
      <div class="exhibition_con certificate">
        <div class="title">高新技术</div>
        <ImagePreview class="wow slideInUp certificate-img" />
      </div>
    </div>
    <!-- 专注消费医疗 -->
    <Bottom />
    <appointment
            :visibleDialog="appointmentVisible"
            @closeAppoint="closeAppoint"
    />
    <Contact />
  </div>
</template>
<script>
  import NavBar1 from "@/components/navBarProduct.vue";
  // import NavBar2 from "@/components/navBar.vue";
  import Bottom from "@/components/bottom.vue";
  import Appointment from "@/components/appointment.vue";
  import Contact from '@/components/contact.vue'

  import { WOW } from 'wowjs'
  export default {
    components: {
      NavBar1,
      // NavBar2,
      Bottom,
      Appointment,
      Contact,
      ImagePreview: () => import('@/components/imagePreview.vue')
    },
    data() {
      return {
        scrollTop:0,
        appointmentVisible:false,
        list: [
          {
            title: '雄厚资本',
            subtitle:'获得超2亿投资（朗盛、耀途、Harvest等），具备长期投入和稳健运营的实力。',
            img: 'https://resource.51beauty.com.cn/qianduan_forever/600867e342144d80ad7db8952431e477/strong-capital.png',
          },
          {
            title: '官方认证',
            subtitle:'腾讯企业微信官方合作伙伴、腾讯千帆计划成员，确保产品与生态无缝衔接。',
            img: 'https://resource.51beauty.com.cn/qianduan_forever/2b7ec58519064472ad2d36cfe77f0df1/official-certification.png',
          },
          {
            title: '安全合规',
            subtitle:'获得公安部网络安全等级保护三级认证，为处理高价值用户数据提供安全保障；资金安全，实时现金流无账期，随时可取。',
            img: 'https://resource.51beauty.com.cn/qianduan_forever/f10dc013f5c44646a26f7c908ee5a14c/security-compliance.png',
          },
          {
            title: '全国团队',
            subtitle:'服务网络覆盖全国百余城，拥有搭建大规模运营团队的能力，可支撑头部品牌的全国性、多业态运营。',
            img: 'https://resource.51beauty.com.cn/qianduan_forever/98a058b63e4f4d2ebfd792517158152a/national-team.png',
          },
        ]
      };
    },
    mounted() {
      new WOW().init()
      window.addEventListener('scroll',this.handleScroll,true)
    },
    methods: {
      // 关闭预约弹层
      closeAppoint (e) {
        this.appointmentVisible = e
      },
      // 打开预约弹层
      openAppoint () {
        this.appointmentVisible = true
      },
      handleScroll(){
        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        this.scrollTop = scrollTop
      },
      article(href){
        window.location = href
      }
    },
  };
</script>
<style scoped lang="less">
  .advertising{
    /deep/ .navbar {
      background: #2C68FF !important;
    }
    .banner{
      background: url("https://resource.51beauty.com.cn/qianduan_forever/d169bfe48cb24e10ac75a3f493e10d51/about-banner.png") no-repeat;
      background-size: cover;
      width: 375px;
      height: 94px;
      .title{
        font-weight: 500;
        font-size: 10px;
        color: #FFFFFF;
        padding-top: 47px;
        text-align: center;
      }
    }
    .content{
      .company-introduction-content {
        background: url("https://resource.51beauty.com.cn/qianduan_forever/4799effef9eb44848737f8a43f7065e3/company-introduction.png") no-repeat;
        background-size: cover;
        width: 375px;
        height: 156px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 75px;
        .content-box {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          .title {
            font-weight: 500;
            font-size: 8px;
            color: #252525;
          }
          .subtitle {
            width: 100px;
            font-weight: 400;
            font-size: 4px;
            color: #727882;
            line-height: 9px;
          }
        }
      }
      .management-team-content {
        background: url("https://resource.51beauty.com.cn/qianduan_forever/cdd49b3a93af44aa9bd155013af4026e/management-team.png") no-repeat;
        background-size: cover;
        width: 375px;
        height: 84px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 6px;
        .title {
          font-weight: 500;
          font-size: 8px;
          color: #FFFFFF;
        }
        .subtitle {
          font-weight: 400;
          font-size: 4px;
          color: #FFFFFF;
          line-height: 9px;
        }
      }
      .list-content {
        width: 375px;
        padding: 25px 60px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 13px;
        .list-item {
          width: 113px;
          height: 69px;
          background: #F6F9FF;
          border-radius: 3px;
          padding: 10px 8px 0 6px;
          position: relative;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          gap: 2px;
          &::before{
            position: absolute;
            top: 0;
            left: 0;
            content: "";
            width: 100%;
            height: 2px;
            background: #2C69FF;
            border-radius: 3px 3px 0px 0px;
          }
          .title-img {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 4px;
            .title {
              font-weight: 500;
              font-size: 8px;
              color: #252525;
            }
            img {
              width: 19px;
              height: 19px;
              align-self: flex-end;
            }
          }
          .subtitle {
            font-weight: 400;
            font-size: 4px;
            color: #727882;
            line-height: 9px;
          }
        }
      }
      >img{
        width: 100%;
        display: block;
      }
    }
    .exhibition{
      background: #FAFBFD;
      padding-bottom: 29px;
      .exhibition_con{

        >div:nth-child(1){
          font-size: 8px;
          font-weight: bold;
          text-align: center;
          padding: 29px 0 12px 0;
        }
        >div:nth-child(2){
          width: 235px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          .exhibition_item{
            width: 73px;
            height: 81px;
            background: #fff;
            cursor: pointer;
            transition: .3s;
            border-radius: 3px;
            .exhibition_img{
              height: 55px;
              background: #FFFFFF;
              margin: 0 auto;
              img{
                width: 59px;
                margin: 0 auto;
                margin-top: 4px;
                display: block;
              }
              box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.06);
            }
            >.exhibition_text{
              background: #fff;
              width: 100%;
              height: 26px;
              margin-top: .3px;
              box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.06);
              border-radius: 0px 0px 3px 3px;
              >div:nth-child(1){
                font-weight: bold;
                font-size: 3px;
                margin-left: 5px;
                padding-top: 5px;
              }
              >div:nth-child(2){
                padding: 0 5px;
                margin-top: 2px;
                color: #273755;
                font-size: 3px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
            }
          }
          .exhibition_item:hover{
            transform: scale(1.1);
          }
        }
      }
    }

  .certificate {
    .certificate-img {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .title {
      padding-top: 16px !important;
    }
  }
  }
</style>